import { Box } from '@wishket/design-system';

import { LinkButton } from './LinkButton';

import { PATH } from '@/shared/constants';

interface LoginMenuProps {
  nextPath: string;
}

export const LoginMenu = ({ nextPath }: LoginMenuProps) => {
  return (
    <Box data-testid="user-menu-box-sign-box" className="flex gap-1">
      <LinkButton href={`${PATH.AUTH_LOGIN}?next=${nextPath}`} name="로그인" />
      <LinkButton
        href={`${PATH.AUTH_SIGNUP}?next=${nextPath}`}
        name="회원가입"
        isSignUp
      />
    </Box>
  );
};
